import {CartData} from "./CartProcessor";

/**
 * What every view of the cart reads from an answer of the server: the number of items and the
 * subtotal. The mini cart (its counts and subtotals), the sentence of the cart (CartFeedback, the
 * format dialogs and the live region) and the name of the cart button (CartBar) take them from
 * here, so they always tell the same story.
 */

/**
 * The number of items: the quantities added up - three prints of one image are three items. The
 * summary of the server carries it; an answer without a summary adds up the quantities of its rows.
 */
export function cartItemCount(data: CartData | null): number {
    if (!data) {
        return 0;
    }
    if (data.summary) {
        return data.summary.itemCount || 0;
    }
    return Array.isArray(data.cart)
        ? data.cart.reduce((sum: number, item: any) => sum + (parseInt(item.count) || 0), 0)
        : 0;
}

/**
 * The subtotal as the server wrote it ("21.60 EUR"), empty without a summary. Its blanks are
 * no-break spaces (U+00A0), so the amount and the currency never stand on two lines - in the cart
 * line of a format dialog, the live region, the bar and its panel. The language string
 * COM_EVENTGALLERY_MONEY_FORMAT stays as it is: it also writes the mails and the documents.
 */
export function cartSubtotal(data: CartData | null): string {
    return data && data.summary && data.summary.subtotal ? String(data.summary.subtotal).replace(/ /g, ' ') : '';
}
